<div
  *ngVar="editing$ | async as editing"
  [class.published-page]="!editing"
  class="control font-main relative shadow-sm group cursor-pointer min-h-50 py-4 px-5 flex flex-col gap-4 border rounded-md border-solid border-navy-50 hover:border-navy-90 {{
    requirementsVisibleCount ? 'bg-white' : 'bg-navy-20'
  }}"
  (click)="openSidePanel($event)"
>
  <div class="flex justify-between items-center">
    <div class="title font-main text-3xl font-extrabold text-navy-90 flex-1 gap-2 min-h-9 flex items-center">
      <span class="group-hover:opacity-100" [class.opacity-50]="!requirementsVisibleCount">
        {{ control.name }}
      </span>

      <div
        class="text-navy-90 text-base font-normal group-hover:opacity-100 whitespace-nowrap"
        [class.opacity-50]="!requirementsVisibleCount"
      >
        |
        @if (editing) {
          <span>
            <span class="font-bold">{{ requirementsVisibleCount }}</span>
            / {{ control.requirements.length }} {{ buildTranslationKey('control.requirementsDisplayed') | translate }}
          </span>
        }

        @if (!editing) {
          <span>
            {{
              requirementsVisibleCount
                | i18nPlural: requirementLabelMapping
                | translate: { numberOfRequirements: requirementsVisibleCount }
            }}
          </span>
        }
      </div>

      @if (!requirementsVisibleCount) {
        <svg-icon class="w-6 h-6" [src]="'eye'"></svg-icon>
      }
    </div>

    @if (editing) {
      <app-icon-button
        class="edit-button"
        [svgIconPath]="'edit'"
        [type]="'basic'"
        [iconSize]="'small'"
        (click)="openEditSidePanel(); $event.stopPropagation()"
      ></app-icon-button>
    }

    @if (editing === false) {
      <div class="show-all-container hidden group-hover:hidden md:group-hover:flex h-8 justify-center items-center bg-navy-40 py-2.5 px-3 rounded-md text-base">
        {{ buildTranslationKey('controlSummary.showAll') | translate }}
      </div>
    }
  </div>

  @for (requirement of requirementsToShow; track trackRequirementBy($index, requirement)) {
    <div
      class="flex gap-2 items-center group-hover:opacity-100 flex-wrap sm:flex-nowrap"
      [class.opacity-50]="!requirementsVisibleCount"
    >
      <div class="flex w-full sm:flex-1 gap-2 items-center">
        <svg-icon class="w-3.5 h-3.5 control-checkmark-icon" [src]="'checkmark'"></svg-icon>
        <div class="text-base text-navy-80">{{ requirement.name }}</div>
      </div>

      @if (control.show_monitoring && requirement.is_monitored) {
        <app-monitored-label [isEditing]="editing"></app-monitored-label>
      }

      @if (control.show_linked_controls && getNumberOfControls(requirement)) {
        <app-controls-label
          [style.min-width.px]="maxControlsLabelWidth"
          [requirement]="requirement"
        ></app-controls-label>
      }
    </div>
  }

  <ng-content></ng-content>
</div>
